/** Hazine — VURGUN TR copy (Smartico GF V4 flows) */
export const TR = {
  brand: 'Hazine',
  brandSub: 'VurgunBet sadakat kulübü',
  nav: {
    home: 'Ana Sayfa',
    missions: 'Görevler',
    levels: 'Seviyeler',
    board: 'Sıralama',
    store: 'Mağaza',
    activity: 'Gelen Kutusu',
  },
  header: {
    topLevel: 'En üst seviye',
    nextLevel: (name, need) => `${name} için ${need} Puan`,
    changeNick: 'Rumuzunu değiştir',
    close: 'Kapat',
    inbox: 'Gelen Kutusu',
    pointsTip: 'Puan bakiyen',
    gemsTip: 'Gems',
    diamondsTip: 'Diamonds',
  },
  home: {
    welcome: (name) => `Merhaba, ${name}`,
    levelTitle: 'Seviyen',
    missionsTitle: 'Öne çıkan görevler',
    storeTitle: 'Mağaza fırsatları',
    boardTitle: 'Haftalık sıralama',
    shortcutsTitle: 'Keşfet',
    seeAll: 'Tümünü gör',
    depositCta: 'Yatırım yap',
    playSport: 'Spor oyna',
    playCasino: 'Casino oyna',
    emptyMissions: 'Şu an öne çıkan görev yok',
    emptyStore: 'Mağaza yakında dolacak',
    emptyBoard: 'Sıralama henüz oluşmadı',
    pointsLabel: 'Puan',
    claimHint: 'Ödülünü almayı unutma',
    claimable: (n) => `${n} ödül bekliyor`,
    inProgress: (n) => `${n} görev devam ediyor`,
    everLabel: 'Toplam kazanılan',
    shortcutMissions: 'Görevler',
    shortcutLevels: 'Seviyeler',
    shortcutBoard: 'Sıralama',
    shortcutStore: 'Mağaza',
  },
  missionTabs: {
    overview: 'Genel',
    available: 'Mevcut',
    locked: 'Kilitli',
    completed: 'Tamamlanan',
    missed: 'Kaçırılan',
  },
  missionStatus: {
    locked: 'Kilitli',
    available: 'Mevcut',
    requires_optin: 'Katılım gerekli',
    in_progress: 'Devam ediyor',
    completed: 'Tamamlandı',
    claimable: 'Ödül bekliyor',
    claimed: 'Ödül alındı',
    missed: 'Süresi doldu',
  },
  missionEmpty: {
    overview: 'Gösterilecek bir şey yok',
    available: 'Şu an mevcut görev yok',
    locked: 'Kilitli görev yok',
    completed: 'Henüz tamamlanan görev yok',
    missed: 'Kaçırılan görev yok',
  },
  missionActions: {
    optIn: 'Katıl',
    claim: 'Ödülü Al',
    claimExpired: 'Ödül süresi doldu',
    ctaDefault: 'Devam et',
    open: 'Detay',
  },
  boardTabs: {
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
  },
  boardSections: {
    leaders: 'Liderler',
    prizes: 'Ödüller',
    rules: 'Kurallar',
  },
  board: {
    empty: 'Henüz lider yok',
    unranked: 'Sıralamada değilsin — Puan kazanarak tırman',
    you: 'Sen',
    place: (n) => `${n}. sıra`,
    prizePts: (n) => `${n} Puan`,
    prevDaily: 'Dünün kazananları',
    prevWeekly: 'Geçen haftanın kazananları',
    prevMonthly: 'Geçen ayın kazananları',
    currDaily: 'Bugünün liderleri',
    currWeekly: 'Güncel sıralama',
    currMonthly: 'Güncel sıralama',
  },
  storeTabs: {
    items: 'Mağaza',
    history: 'Satın alımlar',
  },
  store: {
    all: 'Tümü',
    buyNow: 'Satın Al',
    confirm: 'Satın Al',
    cancel: 'Vazgeç',
    soldOut: 'Tükendi',
    search: 'Ürün ara…',
    shortBy: (n) => `${n} Puan daha gerekli`,
    empty: 'Mağazada ürün yok',
    historyEmpty: 'Bu dönemde satın alma yok',
    buyAgain: 'Tekrar satın al',
    success: 'Satın alma başarılı!',
    noSearch: 'Sonuç bulunamadı',
  },
  levels: {
    current: 'Mevcut seviye',
    reached: 'Ulaşıldı',
    locked: 'Kilitli',
    empty: 'Seviye bulunamadı',
    need: (n) => `${n} Puan gerekli`,
    mapTitle: 'Seviye haritası',
  },
  activity: {
    title: 'Gelen Kutusu',
    points: 'Puan geçmişi',
    all: 'Tümü',
    today: 'Bugün',
    week: 'Bu hafta',
    empty: 'Henüz bildirim yok',
    pointsEmpty: 'Henüz puan hareketi yok',
    reason: {
      mission: 'Görev ödülü',
      deposit: 'Yatırım',
      login: 'Giriş',
      sport_bet: 'Spor bahsi',
      casino_bet: 'Casino bahsi',
      store: 'Mağaza',
      level: 'Seviye',
      admin: 'Yönetici',
      default: 'Puan',
    },
  },
  nick: {
    title: 'Rumuzunu değiştir',
    placeholder: 'Yeni rumuz',
    save: 'Kaydet',
    cancel: 'Vazgeç',
  },
  guest: {
    text: 'Hazine görevlerine katılmak için giriş yap.',
    cta: 'Giriş / Kayıt',
  },
  common: {
    loading: 'Yükleniyor…',
    error: 'Bir şeyler ters gitti',
    retry: 'Tekrar dene',
    points: 'Puan',
    progress: (pct) => `%${pct}`,
  },
};

/** Smartico-style public name mask: abc****xyz */
export function maskPublicName(name, { isMe = false } = {}) {
  const raw = String(name || '').trim();
  if (isMe) return raw || 'Oyuncu';
  if (!raw) return '***';
  if (/\*{2,}|\.{3,}/.test(raw)) return raw;
  if (raw.length <= 2) return `${raw[0] || '*'}*`;
  if (raw.length <= 4) return `${raw.slice(0, 1)}**${raw.slice(-1)}`;
  if (raw.length <= 6) return `${raw.slice(0, 2)}***${raw.slice(-2)}`;
  return `${raw.slice(0, 3)}****${raw.slice(-3)}`;
}

export function reasonLabel(reason) {
  const r = String(reason || '').toLowerCase();
  if (r.includes('mission') || r.includes('görev')) return TR.activity.reason.mission;
  if (r.includes('deposit') || r.includes('yatırım')) return TR.activity.reason.deposit;
  if (r.includes('login') || r.includes('giriş')) return TR.activity.reason.login;
  if (r.includes('sport')) return TR.activity.reason.sport_bet;
  if (r.includes('casino')) return TR.activity.reason.casino_bet;
  if (r.includes('store') || r.includes('mağaza')) return TR.activity.reason.store;
  if (r.includes('level') || r.includes('seviye')) return TR.activity.reason.level;
  if (r.includes('admin')) return TR.activity.reason.admin;
  return reason || TR.activity.reason.default;
}

export function padPos(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v < 0) return '—';
  return String(v).padStart(2, '0');
}
